import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

const withQuantity = (
  WrappedComponent,
  defaultValue = 0,
  step = 1,
  maxValue = Infinity,
  minValue = -Infinity
) => {
  class WithQuantity extends PureComponent {
    constructor(props) {
      super()

      this.state = {
        value: props.defaultValue !== undefined ? props.defaultValue : defaultValue,
        step: props.step !== undefined ? props.step : step,
        maxValue: props.maxValue !== undefined ? props.maxValue : maxValue,
        minValue: props.minValue !== undefined ? props.minValue : minValue
      }
    }

    onChange = ({ value }) => {
      this.props.onChange && this.props.onChange(Number(value))
      this.setState({ value: Number(value) })
    }

    increaseHandler = () => {
      if (this.state.value < this.state.maxValue) {
        const value = this.state.value + this.state.step
        this.props.onChange && this.props.onChange(value)
        this.setState({ value })
      }
    }

    decreaseHandler = () => {
      if (this.state.value > this.state.minValue) {
        const value = this.state.value - this.state.step
        this.props.onChange && this.props.onChange(value)
        this.setState({ value })
      }
    }

    render() {
      return <WrappedComponent
        { ...this.props }
        value={ this.state.value }
        decreaseHandler={ this.decreaseHandler }
        increaseHandler={ this.increaseHandler }
        onChange={ this.onChange } />
    }
  }

  WithQuantity.propTypes = {
    defaultValue: PropTypes.number,
    maxValue: PropTypes.number,
    minValue: PropTypes.number,
    onChange: PropTypes.func,
    step: PropTypes.number
  }

  return WithQuantity
}

export default withQuantity
